import { useEffect } from 'react';
import { subscribeOnScreenOrientationChange } from '@doxyme/ui-foundation/hooks';

const triggerViewportRecalc = () => {
  if (typeof window === 'undefined' || !window.document?.documentElement) {
    return;
  }

  const vh = window.innerHeight * 0.01;
  window.document.documentElement.style.setProperty('--noop', `${vh}px`);
};

/**
 * Fixes a Safari/Chrome bug during device rotation where the page
 * sometimes zooms in and stays scaled, breaking the layout of the video call.
 *
 * This is done by setting a custom `--noop` CSS property, which forces the
 * browser to recalc/repaint the layout. The variable itself is not used in styles.
 *
 * @see https://doxyme.atlassian.net/browse/PROD-3189
 */
export const useFixStuckZoom = () => {
  useEffect(() => {
    triggerViewportRecalc();
    const unsubscribe = subscribeOnScreenOrientationChange(
      triggerViewportRecalc,
    );
    return unsubscribe;
  }, []);
};
